import React from "react";
import PropTypes from "prop-types";
import ScriptureContainer from "./ScriptureContainer";
import ScriptureItems from "./ScriptureItems";
import Popover from "./Popover";
import { isMobileDevice } from "../../utils/mobile";
import ScriptureRefModal from "./ScriptureRefModal";

export default class ScriptureView extends React.Component {
  static propTypes = {
    bibleId: PropTypes.string.isRequired,
    currentChapterRef: PropTypes.string,
    content: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        attrs: PropTypes.shape({}).isRequired
      })
    ).isRequired,
    scriptDirection: PropTypes.string,
    onVerseHover: PropTypes.func,
    onVerseUnhover: PropTypes.func,
    onVerseSelect: PropTypes.func,
    onRefClick: PropTypes.func,
    showVerseActions: PropTypes.bool,
    selectedVerseOrgIds: PropTypes.arrayOf(PropTypes.string),
    highlightedVerseOrgIds: PropTypes.arrayOf(PropTypes.string),
    matchedVerseOrgIds: PropTypes.arrayOf(PropTypes.string),
    highlightSelectedVerse: PropTypes.bool,
    theme: PropTypes.shape({
      hightlightColor: PropTypes.string,
      matchedColor: PropTypes.string,
      selectedColor: PropTypes.string
    })
  };

  static defaultProps = {
    currentChapterRef: null,
    scriptDirection: "ltr",
    selectedVerseOrgIds: [],
    highlightedVerseOrgIds: [],
    matchedVerseOrgIds: [],
    onVerseHover: () => {},
    onVerseUnhover: () => {},
    onVerseSelect: () => {},
    onRefClick: null,
    highlightSelectedVerse: false,
    showVerseActions: false
  };

  state = {
    popover: {
      chapterRef: "",
      position: {}
    },
    refPreview: null
  };

  onVerseSelect = (verses, event) => {
    const { currentChapterRef, onVerseSelect, showVerseActions } = this.props;

    onVerseSelect(verses);

    if (showVerseActions) {
      const scriptureElem = document.getElementById("scripture");
      const containerLeft = scriptureElem.getBoundingClientRect().left;
      const verseTop = event.currentTarget.offsetTop;
      const verseLeft = event.clientX;

      this.setState({
        popover: {
          chapterRef: currentChapterRef,
          position: {
            // center on mobile, use position on screen in desktop
            left: isMobileDevice()
              ? window.innerWidth / 2 - 12 // -12 is size of padding of the scripture view container at mobile
              : verseLeft - containerLeft,
            top: verseTop
          }
        }
      });
    }
  };

  showRefPreview = refId => this.setState({ refPreview: refId });

  hideRefPreview = () => this.setState({ refPreview: null });

  render() {
    const {
      bibleId,
      content,
      currentChapterRef,
      highlightSelectedVerse,
      highlightedVerseOrgIds,
      matchedVerseOrgIds,
      onVerseHover,
      onVerseUnhover,
      selectedVerseOrgIds,
      scriptDirection,
      theme
    } = this.props;

    if (!content) return null;

    this.selectedVerseText = "";
    this.selectedVerseRefs = "";

    return (
      <ScriptureContainer
        id="scripture"
        className="scripture-styles scripture-view"
        scriptDirection={scriptDirection}
        highlightSelectedVerse={highlightSelectedVerse}
        theme={theme}
      >
        <Popover
          bibleId={bibleId}
          currentChapterRef={currentChapterRef}
          selectedVerseOrgIds={selectedVerseOrgIds}
          {...this.state.popover}
        />
        <ScriptureItems
          highlightedVerseOrgIds={highlightedVerseOrgIds}
          matchedVerseOrgIds={matchedVerseOrgIds}
          onVerseHover={onVerseHover}
          onVerseSelect={this.onVerseSelect}
          onVerseUnhover={onVerseUnhover}
          selectedVerseOrgIds={selectedVerseOrgIds}
          showRefPreview={this.showRefPreview}
        >
          {content}
        </ScriptureItems>
        {this.state.refPreview && (
          <ScriptureRefModal
            bibleId={bibleId}
            refId={this.state.refPreview}
            onClose={this.hideRefPreview}
          />
        )}
      </ScriptureContainer>
    );
  }
}
